import React from 'react'
import { Helmet } from "react-helmet"

const Seo = () => {
    return (
        <div>
            <Helmet>
                <title>Cover-Rest Project</title>
                <meta name="description" content="Cover-Rest - Map your Features in Code" />
                <meta name="og:title" property="og:title" content="Cover-Rest - Map your Features in Code"></meta>
                <link rel="canonical" href="https://cover-rest.gitlab.io/"></link>
            </Helmet>
        </div>
    )
}

export default Seo
